import { RouterProvider } from 'react-router-dom'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { ThemeProvider } from 'styled-components'
import { BrandThemeProvider } from './components/molecules'
import { queryClient } from './service'

import { Suspense } from 'react'
import { LoadingFull } from './components/atoms'

import { initialize } from '@grupoboticario/tag-book-sellout'
import { router } from './router'
import { selectTheme } from './themes'
import { globalStyle, GlobalStylesTutorial } from './themes/GlobalStyles'

const initAnalytics = (): void => {
  initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER as string })
}
initAnalytics()

export const App = () => {
  return (
    <BrandThemeProvider>
      <ThemeProvider theme={selectTheme((process.env.REACT_APP_CURRENT_BRAND || '').toString())}>
        <QueryClientProvider client={queryClient}>
          {<GlobalStylesTutorial /> || globalStyle()}

          <Suspense fallback={<LoadingFull />}>
            <RouterProvider router={router} />

            <ReactQueryDevtools initialIsOpen={false} />
          </Suspense>
        </QueryClientProvider>
      </ThemeProvider>
    </BrandThemeProvider>
  )
}
